import React from 'react';
import { ClockIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { hiddenCosts } from '../../data/salesContent';
export function CostSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" data-id="element-100" data-mp="2f7pei0hkj6tm">
      <div className="mx-auto max-w-5xl" data-id="element-101" data-mp="2f6xiwpnz193c">
        <SectionHeading title="¿Cuánto te cuesta seguir preparando todo desde cero?" data-id="element-102" data-mp="2k5qu2bfsco0c" />
        <ul className="mt-12 grid gap-3 sm:grid-cols-2 lg:grid-cols-5" data-id="element-103" data-mp="266r67603kd58">
          {hiddenCosts.map(c => <li key={c} className="flex flex-col items-center gap-3 rounded-2xl border border-ink-line bg-ink-raised px-4 py-6 text-center" data-id="element-104" data-mp="2a8m6q8a7emhy">
              <ClockIcon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-105" data-mp="1w9wa0traqou4" />
              <span className="text-base font-semibold leading-snug text-cream md:text-lg" data-id="element-106" data-mp="218hb0vedhcjm">{c}</span>
            </li>)}
        </ul>
        <div className="mt-12 text-center" data-id="element-107" data-mp="3qk9n51nn7tq1">
          <p className="text-lg text-neutral-400 md:text-xl" data-id="element-108" data-mp="3vlpaj0damcbl">Y después...</p>
          <p className="mt-3 font-display text-2xl font-black uppercase leading-tight text-cream md:text-3xl" data-id="element-109" data-mp="3fvi7641lv93w">
            Todo vuelve a empezar para la siguiente capacitación.
          </p>
        </div>
        <div className="mx-auto mt-14 max-w-3xl border-t border-gold/30 pt-10 text-center" data-id="element-110" data-mp="3onk6u03uold4">
          <p className="text-xl text-neutral-300 md:text-2xl" data-id="element-111" data-mp="3km74hzzyv0ay">El verdadero valor de este sistema no está en cuántas páginas recibís.</p>
          <p className="mt-4 font-display text-2xl font-black uppercase leading-tight text-gold md:text-4xl" data-id="element-112" data-mp="2wxnr56227xc0">
            Está en todo lo que ya no tenés que volver a crear.
          </p>
        </div>
      </div>
    </section>;
}